import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const LandingPageMarketplaces: React.FC = () => {
  const marketplaces = [
    { name: 'EMTUACASA', logo: '/logo_pretoemtuacasa.png' },
    { name: 'AMAZON', logo: '/images/amazon.png' },
    { name: 'WORTEN', logo: '/images/worten.png' },
    { name: 'FNAC', logo: '/images/fnac.png' },
    { name: 'KUANTOKUSTA', logo: '/images/kuantokusta.png' }
  ];

  return (
    <div className="py-16 px-4 md:px-10 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <div className="inline-block mb-6 px-4 py-1 bg-[rgba(140,198,63,0.2)] rounded-full">
          <p className="text-[#8cc63f] font-semibold">VENDA EM TODO LADO</p>
        </div>
        
        <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white">
          Coloque automaticamente à venda os seus produtos nos principais marketplaces:
        </h3>
      </div>
      
      <div className="flex flex-wrap justify-center gap-8 my-12">
        {marketplaces.map((marketplace) => (
          <div 
            key={marketplace.name}
            className="bg-white p-6 rounded-lg shadow-lg transform hover:scale-110 transition-transform"
          >
            {marketplace.logo ? (
              <img 
                src={marketplace.logo} 
                alt={marketplace.name} 
                className="h-12 object-contain"
              />
            ) : (
              <p className="text-[rgb(10,25,47)] font-bold text-xl">{marketplace.name}</p>
            )}
          </div>
        ))}
      </div>
      
      <div className="bg-gradient-to-r from-[#8cc63f] to-[#7ab52f] p-8 rounded-lg max-w-3xl mx-auto shadow-xl">
        <h3 className="text-3xl font-bold text-white mb-4">COMISSÃO REDUZIDA!</h3>
        <p className="text-white text-lg mb-6">Além dos 15% cobrados pelos marketplaces, cobramos apenas 5% adicional por cada venda.</p>
        <Link 
          to="/register" 
          className="inline-flex items-center gap-2 bg-white text-[#0a192f] px-6 py-3 rounded-lg font-bold hover:bg-[#0a192f] hover:text-white transition-colors"
        >
          Começar a vender agora <ExternalLink size={18} />
        </Link>
      </div>
    </div>
  );
};

export default LandingPageMarketplaces;
